import { render, staticRenderFns } from "./BaseButtonLargeOrange.vue?vue&type=template&id=4f243e04&scoped=true&"
import script from "./BaseButtonLargeOrange.vue?vue&type=script&lang=js&"
export * from "./BaseButtonLargeOrange.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonLargeOrange.vue?vue&type=style&index=0&id=4f243e04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f243e04",
  null
  
)

export default component.exports